import styled from "styled-components";

export const Wrapper = styled.ul`
  padding: unset;
`;
